<template>
  <div id="content-brief" class="pb-15">
    <div v-if="!hasContentBriefData">
      <div class="box is-size-5">
        Please rerun to see this data.
        <div>Select "make some changes" and re-run all the steps</div>
      </div>
    </div>
    <div v-else class="show-as-mobileview">
      <div class="summary-section-on-editor">
        <v-card class="is-fullheight flex flex-column white-common-box">
          <div class="pa-5 mainColor--text">
            <v-btn icon :id="`dot-menu`" class="report-card-dot" >
              <img src="/static/dot-3.png"
                width="25px"
                />
            </v-btn>
            <v-menu 
              :activator="`#dot-menu`"
              :close-on-content-click="false"
              bottom offset-y>
              <v-list>
                <v-list-item
                >
                  <div class="item-label d-flex align-center" v-if="secretKey">
                    <img src="/static/copyicon.png" class="copy-to-clipboard-button"
                        v-clipboard:copy="secretKey"
                        v-clipboard:success="() => $notify({ group: 'info', type: 'success', text: 'Copied to clipboard' })"
                        v-clipboard:error="() => $notify({ group: 'info', type: 'error', text: 'can not copy to clipboard' })"
                    />
                      Secret Key:
                    <span class="item-label has-text-grey">{{ secretKey }}</span>
                  </div>
                </v-list-item>
                <v-list-item>
                  <div class="item-label d-flex align-center" v-if="secretKey">
                    <img src="/static/copyicon.png" class="copy-to-clipboard-button"
                        v-clipboard:copy="uniqueUrlForEditor"
                        v-clipboard:success="() => $notify({ group: 'info', type: 'success', text: 'Copied to clipboard' })"
                        v-clipboard:error="() => $notify({ group: 'info', type: 'error', text: 'can not copy to clipboard' })"
                    />
                    Content Editor Url:
                    <a
                      class="item-label has-text-grey is-size-7 word-break-all is-underline"
                      @click="openUrlInNewTab(uniqueUrlForEditor)"
                      >{{ uniqueUrlForEditor }}</a
                    >
                  </div>
                </v-list-item>
              </v-list>
            </v-menu>
            <div class="text-center">
              <div class="font-weight-bold">
                <span class="darkGrayColor--text">Report ID: </span>{{ pageRunId }}
              </div>
              <div class="mt-1 font-weight-bold">
                <span class="darkGrayColor--text">Time: </span>{{ getDateAsLocalString(createdAt) }}
              </div>

              <div class="mt-1 font-weight-bold">
                <span class="darkGrayColor--text">
                  Slug:
                </span>
                  <a
                    class="item-label has-text-grey is-underline"
                    @click="openUrlInNewTab(url)"
                    >{{ getSubFolderPartFromUrl(url) }}</a
                  >
              </div>
              <div class="mt-5">
                <vue-ellipse-progress
                  :progress="fakeScore || score"
                  :half="true"
                  :angle="0"
                  :size="150"
                  :thickness="13"
                  :emptyThickness="13"
                  :color="pageScoreTintColor(fakeScore || score)"
                  :legend-formatter="({ currentValue }) => {
                    return `
                      <div class='mainColor--text font-weight-bold'>${ currentValue }</div>
                    `;
                  }"
                  >
                    <p v-if="!pageNotBuilt"
                      slot="legend-caption" :style="{ 'font-size': '11.5px', 'color': pageScoreTintColor(score) }">
                      {{ fakeScore ? scoreToText(fakeScore) : scoreStatusMsg }}
                    </p>
                </vue-ellipse-progress>
              </div>
              <div class="score-label1">Optimization Score</div>
              <div class="mt-5 darkGrayColor--text">
                Improve this score by getting each section into the target
                range.
              </div>
              <div class="darkGrayColor--text">
                The goal is to get to 100%
              </div>
            </div>
            <div class="text-center mt-5">
              <v-btn
                outlined
                rounded
                color="mainColor"
                class="text-none mainColor--text"
                :disabled="isCalculating || isDemo"
                @click="() => {
                  $emit('needChecklistUpdate')
                }"
                >
                <span v-show="isCalculating" class="calc-loader">
                  <fulfilling-square-spinner
                    :animation-duration="4000"
                    :size="30"
                    color="#FF9B2D"
                  />
                </span>
                Update optimization score
              </v-btn>
            </div>
          </div>
        </v-card>
      </div>      
      <div class ='my-6'>
        <v-card class="white-common-box">
          <div class="pa-4">
              <div class="font-large">Current word count</div>
              <div class="mt-4">
                  <v-row>
                      <v-col cols="12" lg="6" sm="12">
                          <div class="darkGrayColor--text">{{this.calcWordCountRecommendation(fakeWC() || wordCountData[0],wordCountData[1])}}</div>
                      </v-col>
                      <v-col cols="12" lg="6" sm="12">
                          <div class="d-flex justify-space-between">
                              <div class="font-large">{{ fakeWC() || wordCountData[0] }}</div>
                              <div class="font-weight-bold">Target: {{ wordCountData[1] }}</div>
                          </div>
                          <div class="mt-2">
                              <v-progress-linear 
                                :color="pageScoreTintColor((fakeWC() || wordCountData[0]) * 100 / wordCountData [1])"
                                :value="100* (fakeWC()|| wordCountData[0])/wordCountData[1]" :height="10"></v-progress-linear>
                          </div>
                      </v-col>
                  </v-row>
              </div>
          </div>
      </v-card>
      </div>
      <div class="sort-filter-block flex">
        <div>
          <span class="view-type-selector">
            <span class="is-size-7 mainColor--text">View as</span>
            <i
              class="material-icons"
              :class="{ 'is-active': termDispType == 'table' }"
              @click="termDispType = 'table'"
              >format_list_bulleted</i
            >
            <i
              class="material-icons"
              :class="{ 'is-active': termDispType == 'list' }"
              @click="termDispType = 'list'"
              >apps</i
            >
          </span>
        </div>
        <div class="flex-grow-1 is-size-7 pl10 mainColor--text">
          Sort by:
          <select v-model="sortMethod" class="is-size-7 mainColor--text">
            <option value="importance">Most Important</option>
            <option value="deficit">Deficit</option>
            <option value="alphabetic">Alphabetic</option>
            <option value="status">Status</option>
          </select>
        </div>
      </div>

      <div class="content-brief-box">
        <div class="d-flex">
          <!-- <hr class="flex-grow-1" style="margin: 0.6rem 0;"/> -->
          <div v-if="isCollapseSearchEngineTitleArea" class="flex-grow-1">
            <div class="d-flex align-center">
              <div class="section-title">Search Engine Title</div>
              <div>
                <span
                  class="section-state-box ml-5"
                  :class="getStopLightStateTextForSection('title')[1]"
                >{{ getStopLightStateTextForSection('title')[0] }}</span>
              </div>
            </div>
          </div>
          <div v-else class="flex-grow-1">
            <div class="d-flex align-center">
              <div>
                <div class="d-flex align-center">
                  <div class="section-title">Search Engine Title</div>
                  <v-tooltip bottom color="transparent">
                    <template v-slot:activator="{ on, attrs }">
                      <i class="material-icons info-icon-size ml-2 mainColor--text" v-bind="attrs" v-on="on">info</i>
                    </template>
                    <div class="white-bg-tooltip">
                      In your website editor, this is your tag, sometimes called the meta title.
                    </div>
                  </v-tooltip>
                  
                </div>
                <!-- Complete / Incomplete -->
                <div class="control darkGrayColor--text">
                  <label class="radio">
                    <input
                      type="radio"
                      name="title_status"
                      :disabled="isDemo"
                      :checked="contentBriefStatus['title'] == 'Completed'"
                      @click.stop="
                        updateContentBriefSectionStatus('title', 'Completed')
                      "
                    />
                    Complete
                  </label>
                  <label class="radio">
                    <input
                      type="radio"
                      name="title_status"
                      :disabled="isDemo"
                      :checked="contentBriefStatus['title'] == 'InCompleted'"
                      @click.stop="
                        updateContentBriefSectionStatus('title', 'InCompleted')
                      "
                    />
                    Incomplete
                  </label>
                </div>              
              </div>
              <div>
                <span
                  class="section-state-box ml-5"
                  :class="getStopLightStateTextForSection('title')[1]"
                >{{ getStopLightStateTextForSection('title')[0] }}</span>
              </div>
            </div>
            <div
              v-if="showNoSecondaryKeywordsInSection('title')"
              class="no-secondary-keywords pl-0">Secondary keywords found.
            </div>
            <div class="d-flex mt-5">
              <div class="flex-grow-1">
                <span>
                  <template v-if="termDispType == 'list'">
                    ( {{ titleTotal["current"] }} / {{ titleTotal["min"] }} - {{ titleTotal["max"] }} )
                  </template>
                  <div v-else class="section-count-disp">
                    <div>
                      <div class="section-count-number">{{ titleTotal["current"] }}</div>
                      <div>Current count</div>
                    </div>
                    <div>
                      <div class="section-count-number">{{ titleTotal["min"] }} - {{ titleTotal["max"] }}</div>
                      <div>Important terms range</div>
                    </div>
                  </div>
                </span>
              </div>
              <div class="text-right">
                <a class="my-notes-btn" @click.stop="isDemo ? null : displayNoteModalFor('title')">
                  <i :class="`material-icons ${$store.getters.isDemoUser ? 'grayColor--text' : ''}`">border_color</i>
                  <span :class="$store.getters.isDemoUser ? 'grayColor--text' : ''">My notes</span>
                </a>
              </div>
            </div>
          </div>
          <a
            v-if="!isCollapseSearchEngineTitleArea"
            @click.stop="isCollapseSearchEngineTitleArea = true">
            <span class="material-icons fold_icon">unfold_less</span>
          </a>
          <a v-else @click.stop="isCollapseSearchEngineTitleArea = false">
            <span class="material-icons fold_icon">unfold_more</span>
          </a>
        </div>
        <div
          v-if="!isCollapseSearchEngineTitleArea"
          class="mb10"
        >
          <span v-show="showPageTitleExplainText"
            class="has-text-grey has-text-weight-light is-italic">
            Make sure that your title contains your important terms in the
            suggested range. You do not need to use every important term. You
            should select the ones you like and use them to reach the target
            range for the section.<br/>
            Use your competitor titles in Content prompts for inspiration.<br/>
            Your Search Engine Title, the title that search engines see, and
            your H1, the title that humans see, should be as identical as
            possible.
          </span>
          <a
            class="show-hide-link"
            @click.stop="showPageTitleExplainText = !showPageTitleExplainText"
            >{{ showPageTitleExplainText ? "Hide" : "More info" }}</a
          >
        </div>
        <div v-if="!isCollapseSearchEngineTitleArea">
          <div v-if="termDispType == 'list'">
            <span
              v-for="(item, idx) in titleData"
              :key="idx"
              class="content-brief-tag"
              :style="{
                'border-color': getStopLightColorForItem('title', item)
              }"
            >
              <span>{{ item.term.phrase }}</span>
              <span
                >{{ item.contentBrief.current }} /
                {{
                  item.term.type == "keyword"
                    ? Math.round(
                        item.contentBrief.target *
                          TARGET_MIN_PERCENTAGE["title"]
                      ) +
                      " - " +
                      item.contentBrief.target
                    : item.contentBrief.targetMin +
                      " - " +
                      item.contentBrief.targetMax
                }}</span
              >
            </span>
          </div>
          <div v-else-if="termDispType == 'table'">
            <table class="signal-table" style="table-layout: fixed;">
              <thead>
                <tr>
                  <th style="width: 45%;">Important Term</th>
                  <th>Current Usage</th>
                  <th>Target Range</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in titleData" :key="idx">
                  <td>
                    <input :disabled="isDemo" type="checkbox" class="term-checkbox"
                      v-model="selectedCBItems"
                      :value="{
                        sectionName: 'title',
                        item: item
                      }"
                       />
                    {{ item.term.phrase }}
                  </td>
                  <td>
                    {{ item.contentBrief.current }}
                    
                    <v-tooltip left color="transparent">
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          class="stoplights-box"
                          :style="{ background: getStopLightColorForItem('title', item) }"
                          v-bind="attrs"
                          v-on="on"
                        ></span>
                      </template>
                      <div class="white-bg-tooltip small-tooltip">{{getTooltipForColor(getStopLightColorForItem('title', item))}}</div>
                    </v-tooltip>
                  </td>
                  <td>
                    <span class="target-range">
                      {{
                        item.term.type == "keyword"
                          ? Math.round(
                              item.contentBrief.target *
                                TARGET_MIN_PERCENTAGE["title"]
                            ) +
                            " - " +
                            item.contentBrief.target
                          : item.contentBrief.targetMin +
                            " - " +
                            item.contentBrief.targetMax
                      }}
                    </span>
                    <span
                      v-if="item.term.type == 'keyword'"
                      class="cb-tag must-use clickable tooltip is-tooltip-left is-tooltip-multiline"
                      data-tooltip="Using your exact keyword is critical to SEO success"
                      >Must Use
                    </span>
                    <span
                      v-if="isSecondaryKeyword(item.term.phrase)"
                      class="cb-tag secondary-kw clickable tooltip is-tooltip-left is-tooltip-multiline"
                      data-tooltip="Use your secondary keyword"
                      >Secondary KW
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            Unsupported View Type
          </div>
          <div>
            <a class="download-link" @click.stop="downloadAsTxt('title')"
              >Download as .txt</a
            >
          </div>
        </div>
      </div>
      <div class="content-brief-box">
        <div class="d-flex">
          <!-- <hr class="flex-grow-1" style="margin: 0.6rem 0;"/> -->
          <div v-if="isCollapsePageTitleArea" class="flex-grow-1">
            <div class="d-flex align-center">
              <div class="section-title">Page Title</div>
              <div>
                <span
                  class="section-state-box ml-5"
                  :class="getStopLightStateTextForSection('pageTitle')[1]"
                >{{ getStopLightStateTextForSection('pageTitle')[0] }}</span>
              </div>
            </div>
          </div>
          <div v-else class="flex-grow-1">
            <div class="d-flex align-center">
              <div>
                <div class="d-flex align-center">
                  <div class="section-title">Page Title</div>
                  <v-tooltip bottom color="transparent">
                    <template v-slot:activator="{ on, attrs }">
                      <i class="material-icons info-icon-size ml-2 mainColor--text" v-bind="attrs" v-on="on">info</i>
                    </template>
                    <div class="white-bg-tooltip">
                      In your website editor this is your H1 tag
                    </div>
                  </v-tooltip>
                </div>
                <!-- Complete / Incomplete -->
                <div class="control darkGrayColor--text">
                  <label class="radio">
                    <input
                      type="radio"
                      name="pageTitle_status"
                      :disabled="isDemo"
                      :checked="contentBriefStatus['pageTitle'] == 'Completed'"
                      @click.stop="
                        updateContentBriefSectionStatus('pageTitle', 'Completed')
                      "
                    />
                    Complete
                  </label>
                  <label class="radio">
                    <input
                      type="radio"
                      name="pageTitle_status"
                      :disabled="isDemo"
                      :checked="contentBriefStatus['pageTitle'] == 'InCompleted'"
                      @click.stop="
                        updateContentBriefSectionStatus(
                          'pageTitle',
                          'InCompleted'
                        )
                      "
                    />
                    Incomplete
                  </label>
                </div>
              </div>
              <div>
                <span
                  class="section-state-box ml-5"
                  :class="getStopLightStateTextForSection('pageTitle')[1]"
                >{{ getStopLightStateTextForSection('pageTitle')[0] }}</span>
              </div>
            </div>
            <div>
              <span
                v-if="showNoSecondaryKeywordsInSection('pageTitle')"
                class="no-secondary-keywords pl-0">Secondary keywords found.
              </span>
            </div>
            <div class="d-flex mt-5">
              <div class="flex-grow-1">
                <span class="term-range-size mainColor--text">
                  <template v-if="termDispType == 'list'">
                    ( {{ pageTitleTotal["current"] }} / {{ pageTitleTotal["min"] }} - {{ pageTitleTotal["max"] }} )
                  </template>
                  <div v-else class="section-count-disp">
                    <div>
                      <div class="section-count-number">{{ pageTitleTotal["current"] }}</div>
                      <div>Current count</div>
                    </div>
                    <div>
                      <div class="section-count-number">{{ pageTitleTotal["min"] }} - {{ pageTitleTotal["max"] }}</div>
                      <div>Important terms range</div>
                    </div>
                  </div>
                </span>
                
              </div>
              <div class="text-right">
                <a class="my-notes-btn"
                  @click.stop="isDemo ? null : displayNoteModalFor('pageTitle')"
                >
                <i :class="`material-icons ${$store.getters.isDemoUser ? 'grayColor--text' : ''}`">border_color</i>
                <span :class="$store.getters.isDemoUser ? 'grayColor--text' : ''">My notes</span>
                </a>
              </div>
            </div>
          </div>
          <a
            v-if="!isCollapsePageTitleArea"
            @click.stop="isCollapsePageTitleArea = true"
            ><span class="material-icons fold_icon">unfold_less</span></a
          >
          <a v-else @click.stop="isCollapsePageTitleArea = false"
            ><span class="material-icons fold_icon">unfold_more</span></a
          >
        </div>
        <div
          v-if="!isCollapsePageTitleArea"
          class="mb10"
        >
          <span v-show="showPageTitleExplainText"
            class="has-text-grey has-text-weight-light is-italic">>
            Make sure that your page title contains your important terms in the
            suggested range. You do not need to use every important term. You
            should select the ones you like and use them to reach the target
            range for the section.<br/>
            Use your competitor titles in the Content prompts for inspiration.<br/>
            Your Search Engine title, the title that search engines see, and
            your H1, the title that humans see, should be as identical as
            possible. You should only have one H1, one title visible on your
            page.
          </span>
          <a
            class="show-hide-link"
            @click.stop="showPageTitleExplainText = !showPageTitleExplainText"
            >{{ showPageTitleExplainText ? "Hide" : "More info" }}</a
          >
        </div>
        <div v-if="!isCollapsePageTitleArea">
          <div v-if="termDispType == 'list'">
            <span
              v-for="(item, idx) in pageTitleData"
              :key="idx"
              class="content-brief-tag"
              :style="{
                'border-color': getStopLightColorForItem('pageTitle', item)
              }"
            >
              <span>{{ item.term.phrase }}</span>
              <span
                >{{ item.contentBrief.current }} /
                {{
                  item.term.type == "keyword"
                    ? Math.round(
                        item.contentBrief.target *
                          TARGET_MIN_PERCENTAGE["pageTitle"]
                      ) +
                      " - " +
                      item.contentBrief.target
                    : item.contentBrief.targetMin +
                      " - " +
                      item.contentBrief.targetMax
                }}</span
              >
            </span>
          </div>
          <div v-else-if="termDispType == 'table'">
            <table class="signal-table" style="table-layout: fixed;">
              <thead>
                <tr>
                  <th style="width: 45%;">Important Term</th>
                  <th>Current Usage</th>
                  <th>Target Range</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in pageTitleData" :key="idx">
                  <td>
                    <input :disabled="isDemo" type="checkbox" class="term-checkbox"
                      v-model="selectedCBItems"
                      :value="{
                        sectionName: 'pageTitle',
                        item: item
                      }"
                       />
                    {{ item.term.phrase }}
                  </td>
                  <td>
                    {{ item.contentBrief.current }}
                    
                    <v-tooltip left color="transparent">
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          class="stoplights-box"
                          :style="{ background: getStopLightColorForItem('pageTitle', item) }"
                          v-bind="attrs"
                          v-on="on"
                        ></span>
                      </template>
                      <div class="white-bg-tooltip small-tooltip">{{getTooltipForColor(getStopLightColorForItem('pageTitle', item))}}</div>
                    </v-tooltip>
                  </td>
                  <td>
                    <span class="target-range">
                      {{
                        item.term.type == "keyword"
                          ? Math.round(
                              item.contentBrief.target *
                                TARGET_MIN_PERCENTAGE["pageTitle"]
                            ) +
                            " - " +
                            item.contentBrief.target
                          : item.contentBrief.targetMin +
                            " - " +
                            item.contentBrief.targetMax
                      }}
                    </span>
                    <span
                      v-if="item.term.type == 'keyword'"
                      class="cb-tag must-use clickable tooltip is-tooltip-left is-tooltip-multiline"
                      data-tooltip="Using your exact keyword is critical to SEO success"
                      >Must Use
                    </span>
                    <span
                      v-if="isSecondaryKeyword(item.term.phrase)"
                      class="cb-tag secondary-kw clickable tooltip is-tooltip-left is-tooltip-multiline"
                      data-tooltip="Use your secondary keyword"
                      >Secondary KW
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            Unsupported View Type
          </div>
          <div
            v-if="!hasPageTitleData"
            class="notification is-warning is-italic"
          >
            Please Re-Run and select "Make Changes" to see this new feature.
          </div>
          <div>
            <a class="download-link" @click.stop="downloadAsTxt('pageTitle')"
              >Download as .txt</a
            >
          </div>
        </div>
      </div>
      <div class="content-brief-box">
        <div class="d-flex">
          <div v-if="isCollapseSubHeadingsArea" class="flex-grow-1">
            <div class="d-flex align-center">
              <div class="section-title">SubHeadings</div>
              <div>
                <span
                  class="section-state-box ml-5"
                  :class="getStopLightStateTextForSection('subHeadings')[1]"
                >{{ getStopLightStateTextForSection('subHeadings')[0] }}</span>
              </div>
            </div>
          </div>
          <div v-else class="flex-grow-1">
            <div class="d-flex align-center">
              <div>
                <div class="d-flex align-center">
                  <div class="section-title">SubHeadings</div>
                  <v-tooltip bottom color="transparent">
                    <template v-slot:activator="{ on, attrs }">
                      <i class="material-icons info-icon-size ml-2 mainColor--text" v-bind="attrs" v-on="on">info</i>
                    </template>
                    <div class="white-bg-tooltip">
                      In your website editor these are H2 or H3 tags
                    </div>
                  </v-tooltip>
                </div>
                <!-- Complete / Incomplete -->
                <div class="control darkGrayColor--text">
                  <label class="radio">
                    <input
                      type="radio"
                      name="subheadings_status"
                      :disabled="isDemo"
                      :checked="contentBriefStatus['subHeadings'] == 'Completed'"
                      @click.stop="
                        updateContentBriefSectionStatus(
                          'subHeadings',
                          'Completed'
                        )
                      "
                    />
                    Complete
                  </label>
                  <label class="radio">
                    <input
                      type="radio"
                      name="subheadings_status"
                      :disabled="isDemo"
                      :checked="
                        contentBriefStatus['subHeadings'] == 'InCompleted'
                      "
                      @click.stop="
                        updateContentBriefSectionStatus(
                          'subHeadings',
                          'InCompleted'
                        )
                      "
                    />
                    Incomplete
                  </label>
                </div>
                <div>
                  <span v-if="showNoSecondaryKeywordsInSection('subHeadings')"
                    class="no-secondary-keywords pl-0">Secondary keywords found.
                  </span>
                </div>
              </div>
              <div>
                <span
                  class="section-state-box ml-5"
                  :class="getStopLightStateTextForSection('subHeadings')[1]"
                >{{ getStopLightStateTextForSection('subHeadings')[0] }}</span>
              </div>
            </div>
            <div class="d-flex mt-5">
              <div class="flex-grow-1">
                <span class="term-range-size mainColor--text">
                  <template v-if="termDispType == 'list'">
                    ( {{ subTitleTotal["current"] }} / {{ subTitleTotal["min"] }} - {{ subTitleTotal["max"] }} )
                  </template>
                  <div v-else class="section-count-disp">
                    <div>
                      <div>{{ subTitleTotal["current"] }}</div>
                      <div class="section-count-number">Current count</div>
                    </div>
                    <div>
                      <div>{{ subTitleTotal["min"] }} - {{ subTitleTotal["max"] }}</div>
                      <div class="section-count-number">Important terms range</div>
                    </div>
                  </div>
                </span>
                
              </div>
              <div class="text-right">
                <a class="my-notes-btn" @click.stop="isDemo ? null : displayNoteModalFor('subHeadings')">
                  <i :class="`material-icons ${$store.getters.isDemoUser ? 'grayColor--text' : ''}`">border_color</i>
                  <span :class="$store.getters.isDemoUser ? 'grayColor--text' : ''">Notes</span>
                </a>
              </div>
            </div>
          </div>
          <a
            v-if="!isCollapseSubHeadingsArea"
            @click.stop="isCollapseSubHeadingsArea = true"
            ><span class="material-icons fold_icon">unfold_less</span></a
          >
          <a v-else @click.stop="isCollapseSubHeadingsArea = false"
            ><span class="material-icons fold_icon">unfold_more</span></a
          >
        </div>
        <div
          v-if="!isCollapseSubHeadingsArea"
          class="mb10"
        >
          <span v-show="showSubtitlesExplainText"
            class="has-text-grey has-text-weight-light is-italic">
            No matter how many subheadings/subtitles are on your page makes sure
            those subheadings/subtitles include the important terms below. You
            do not have to use every important term. You do not have to get
            every important term inside its individual target range.<br />
            The goal is to use as many of the important terms below as needed so
            that the Subheadings Section as a whole gets inside the section's
            target range.<br />
            Use the relevant related keywords at the bottom of the dashboard for
            inspiration on your subtitles.
            <b>
              If you see competitor brand names in this list we highly
              recommend that you re-run and remove them.
            </b>
          </span>
          <a
            class="show-hide-link"
            @click.stop="showSubtitlesExplainText = !showSubtitlesExplainText"
            >{{ showSubtitlesExplainText ? "Hide" : "More info" }}</a
          >
        </div>
        <div class="" v-if="!isCollapseSubHeadingsArea">
          <div v-if="termDispType == 'list'">
            <span
              v-for="(item, idx) in subHeadingsData"
              :key="idx"
              class="content-brief-tag"
              :style="{
                'border-color': getStopLightColorForItem('subHeadings', item)
              }"
            >
              <span>{{ item.term.phrase }}</span>
              <span
                >{{ item.contentBrief.current }} /
                {{
                  item.term.type == "keyword"
                    ? Math.round(
                        item.contentBrief.target *
                          TARGET_MIN_PERCENTAGE["subHeadings"]
                      ) +
                      " - " +
                      item.contentBrief.target
                    : item.contentBrief.targetMin +
                      " - " +
                      item.contentBrief.targetMax
                }}</span
              >
            </span>
          </div>
          <div v-else-if="termDispType == 'table'">
            <table class="signal-table" style="table-layout: fixed;">
              <thead>
                <tr>
                  <th style="width: 45%;">Important Term</th>
                  <th>Current Usage</th>
                  <th>Target Range</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in subHeadingsData" :key="idx">
                  <td>
                    <input :disabled="isDemo" type="checkbox" class="term-checkbox"
                      v-model="selectedCBItems"
                      :value="{
                        sectionName: 'subHeadings',
                        item: item
                      }"
                       />
                    {{ item.term.phrase }}
                  </td>
                  <td>
                    {{ item.contentBrief.current }}
                    
                    <v-tooltip left color="transparent">
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          class="stoplights-box"
                          :style="{ background: getStopLightColorForItem('subHeadings', item) }"
                          v-bind="attrs"
                          v-on="on"
                        ></span>
                      </template>
                      <div class="white-bg-tooltip small-tooltip">{{getTooltipForColor(getStopLightColorForItem('subHeadings', item))}}</div>
                    </v-tooltip>
                  </td>
                  <td>
                    <span class="target-range">
                      {{
                        item.term.type == "keyword"
                          ? Math.round(
                              item.contentBrief.target *
                                TARGET_MIN_PERCENTAGE["subHeadings"]
                            ) +
                            " - " +
                            item.contentBrief.target
                          : item.contentBrief.targetMin +
                            " - " +
                            item.contentBrief.targetMax
                      }}
                    </span>
                    <span
                      v-if="
                        item.term.type == 'keyword' &&
                          item.contentBrief.target > 0
                      "
                      class="cb-tag must-use clickable tooltip is-tooltip-left is-tooltip-multiline"
                      data-tooltip="Using your exact keyword is critical to SEO success"
                      >Must Use
                    </span>
                    <span
                      v-if="isSecondaryKeyword(item.term.phrase)"
                      class="cb-tag secondary-kw clickable tooltip is-tooltip-left is-tooltip-multiline"
                      data-tooltip="Use your secondary keyword"
                      >Secondary KW
                    </span>
                    <span
                      v-if="isNLPTerm(item.term.phrase)"
                      class="cb-tag nlp-term clickable tooltip is-tooltip-left"
                      data-tooltip="Entities from POP's Natural Language Processing list"
                      >NLP
                    </span>
                    <span
                      v-if="item.term.isGoogleNLPTerm"
                      class="cb-tag google-nlp-term clickable tooltip is-tooltip-left"
                      data-tooltip="Entities from Google's Natural Language Processing list"
                      >Google NLP
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            Unsupported View Type
          </div>
          <div>
            <a class="download-link" @click.stop="downloadAsTxt('subHeadings')"
              >Download as .txt</a
            >
          </div>
        </div>
      </div>
      <div class="content-brief-box">
        <div class="d-flex">
          <div v-if="isCollapseMainContentArea" class="flex-grow-1">
            <div class="d-flex align-center">
              <div class="section-title">Main Content</div>
              <div>
                <span
                  class="section-state-box ml-5"
                  :class="getStopLightStateTextForSection('p')[1]"
                >{{ getStopLightStateTextForSection('p')[0] }}</span>
              </div>
            </div>
          </div>
          <div v-else class="flex-grow-1">
            <div class="d-flex align-center">
              <div>
                <div class="d-flex align-center">
                  <div class="section-title">Main Content</div>
                  <v-tooltip bottom color="transparent">
                    <template v-slot:activator="{ on, attrs }">
                      <i class="material-icons info-icon-size ml-2 mainColor--text" v-bind="attrs" v-on="on">info</i>
                    </template>
                    <div class="white-bg-tooltip">
                      Any text on your page that is in a paragraph, list, or table.
                    </div>
                  </v-tooltip>
                </div>
                <!-- complete / incomplete -->
                <div class="control darkGrayColor--text">
                  <label class="radio">
                    <input
                      type="radio"
                      name="maincontent_status"
                      :disabled="isDemo"
                      :checked="contentBriefStatus['p'] == 'Completed'"
                      @click.stop="
                        updateContentBriefSectionStatus('p', 'Completed')
                      "
                    />
                    Complete
                  </label>
                  <label class="radio">
                    <input
                      type="radio"
                      :disabled="isDemo"
                      name="maincontent_status"
                      :checked="contentBriefStatus['p'] == 'InCompleted'"
                      @click.stop="
                        updateContentBriefSectionStatus('p', 'InCompleted')
                      "
                    />
                    Incomplete
                  </label>
                </div>
              </div>
              <div>
                <span
                  class="section-state-box ml-5"
                  :class="getStopLightStateTextForSection('p')[1]"
                >{{ getStopLightStateTextForSection('p')[0] }}</span>
              </div>
            </div>
            <div>
              <span
                v-if="showNoSecondaryKeywordsInSection('p')"
                class="no-secondary-keywords pl-0">Secondary keywords found.
              </span>
            </div>
            <div class="d-flex mt-5">
              <div class="flex-grow-1">
                <span class="term-range-size mainColor--text">
                  <template v-if="termDispType == 'list'">
                    ( {{ contentTotal["current"] }} / {{ contentTotal["min"] }} -
                    {{ contentTotal["max"] }} )
                  </template>
                  <div v-else class="section-count-disp">
                    <div>
                      <div class="section-count-number">{{ contentTotal["current"] }}</div>
                      <div>Current count</div>
                    </div>
                    <div>
                      <div class="section-count-number">{{ contentTotal["min"] }} - {{ contentTotal["max"] }}</div>
                      <div>Important terms range</div>
                    </div>
                  </div>
                </span>
                
              </div>
              <div class="text-right">
                <a class="my-notes-btn" @click.stop="isDemo ? null : displayNoteModalFor('p')">
                  <i :class="`material-icons ${$store.getters.isDemoUser ? 'grayColor--text' : ''}`">border_color</i>
                  <span :class="$store.getters.isDemoUser ? 'grayColor--text' : ''">My notes</span>
                </a>
              </div>
            </div>
          </div>
          <a
            v-if="!isCollapseMainContentArea"
            @click.stop="isCollapseMainContentArea = true"
            ><span class="material-icons fold_icon">unfold_less</span></a
          >
          <a v-else @click.stop="isCollapseMainContentArea = false"
            ><span class="material-icons fold_icon">unfold_more</span></a
          >
        </div>
        <div v-if="!isCollapseMainContentArea"
          class="mb10">
          <span v-show="showMainContentExplainText"
            class="has-text-grey has-text-weight-light is-italic">
            Use the suggested terms below to optimize the main content on your
            page. You do not have to use every important term. You do not have
            to get every important term inside its individual target range.<br />
            The goal is to use as many of the important terms below as needed so
            that the Main Content Section as a whole gets inside the section's
            target range.<br />
            A good approach is to provide information that answers the questions
            your readers have about your target keyword. It's often good to
            write your main content first and then edit for the important terms.
            Use the related questions at the bottom of the dashboard for
            inspiration on the questions your readers may need answered.
            <b>
              If you see competitor brand names in this list we highly
              recommend that you re-run and remove them.
            </b>
          </span>
          <a
            class="show-hide-link"
            @click.stop="
              showMainContentExplainText = !showMainContentExplainText
            "
            >{{ showMainContentExplainText ? "Hide" : "More info" }}</a
          >
        </div>
        <div v-if="!isCollapseMainContentArea">
          <div v-if="termDispType == 'list'">
            <span
              v-for="(item, idx) in bodyContentData"
              :key="idx"
              class="content-brief-tag"
              :style="{ 'border-color': getStopLightColorForItem('p', item) }"
            >
              <span>{{ item.term.phrase }}</span>
              <span
                >{{ item.contentBrief.current }} /
                {{
                  item.term.type == "keyword"
                    ? Math.round(
                        item.contentBrief.target * TARGET_MIN_PERCENTAGE["p"]
                      ) +
                      " - " +
                      item.contentBrief.target
                    : item.contentBrief.targetMin +
                      " - " +
                      item.contentBrief.targetMax
                }}</span
              >
            </span>
          </div>
          <div v-else-if="termDispType == 'table'">
            <table class="signal-table" style="table-layout: fixed;">
              <thead>
                <tr>
                  <th style="width: 45%;">Important Term</th>
                  <th>Current Usage</th>
                  <th>Target Range</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in bodyContentData" :key="idx">
                  <td>
                    <input :disabled="isDemo" type="checkbox" class="term-checkbox"
                      v-model="selectedCBItems"
                      :value="{
                        sectionName: 'p',
                        item: item
                      }"
                       />
                    {{ item.term.phrase }}
                  </td>
                  <td>
                    {{ item.contentBrief.current }}
                    <v-tooltip left color="transparent">
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          class="stoplights-box"
                          :style="{ background: getStopLightColorForItem('p', item) }"
                          v-bind="attrs"
                          v-on="on"
                        ></span>
                      </template>
                      <div class="white-bg-tooltip small-tooltip">{{getTooltipForColor(getStopLightColorForItem('p', item))}}</div>
                    </v-tooltip>
                  </td>
                  <td>
                    <span class="target-range">
                      {{
                        item.term.type == "keyword"
                          ? Math.round(
                              item.contentBrief.target *
                                TARGET_MIN_PERCENTAGE["p"]
                            ) +
                            " - " +
                            item.contentBrief.target
                          : item.contentBrief.targetMin +
                            " - " +
                            item.contentBrief.targetMax
                      }}
                    </span>
                    <span
                      v-if="
                        item.term.type == 'keyword' &&
                          item.contentBrief.target > 0
                      "
                      class="cb-tag must-use clickable tooltip is-tooltip-left is-tooltip-multiline"
                      data-tooltip="Using your exact keyword is critical to SEO success"
                      >Must Use
                    </span>
                    <span
                      v-if="isSecondaryKeyword(item.term.phrase)"
                      class="cb-tag secondary-kw clickable tooltip is-tooltip-left is-tooltip-multiline"
                      data-tooltip="Use your secondary keyword"
                      >Secondary KW
                    </span>
                    <span
                      v-if="isNLPTerm(item.term.phrase)"
                      class="cb-tag nlp-term clickable tooltip is-tooltip-left"
                      data-tooltip="Entities from POP's Natural Language Processing list"
                      >NLP
                    </span>
                    <span
                      v-if="isGoogleNLPTerm(item.term.phrase)"
                      class="cb-tag google-nlp-term clickable tooltip is-tooltip-left"
                      data-tooltip="Entities from Google's Natural Language Processing list"
                      >Google NLP
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            Unsupported View Type
          </div>
          <div>
            <a class="download-link" @click.stop="downloadAsTxt('p')"
              >Download as .txt</a
            >
          </div>
        </div>
      </div>
    </div>

    <div class="modal" :class="{ 'is-active': showNoteModal }">
      <div class="modal-background" @click="hideNoteModalAction"></div>
      <div class="modal-content">
        <div class="box modal-container">
          <div class="d-flex">
            <p class="title-font is-size-5" style="flex-grow: 1;">
              Notes (
              {{ selectedSecitonDisplayName }}
              )
            </p>
            <i
              class="fa fa-close"
              @click="hideNoteModalAction"
              style="cursor: pointer; font-size: 1.5rem;"
            ></i>
          </div>
          <div>
            <textarea
              class="textarea"
              v-model="noteText"
              placeholder="Write Note here.."
              :rows="2"
            >
            </textarea>
            <div v-if="currentNote" class="mt5">
              <v-btn rounded
                color="profileAnchorColor"
                class="button-with-icon text-none white--text"
                :disabled="noteText.trim() == ''"
                @click="updateNote"
              >
                Update Note
              </v-btn>
              <v-btn rounded
                color="grayColor"
                class="button-with-icon text-none white--text ml10"
                @click="cancelEditNoteMode">
                Cancel
              </v-btn>
            </div>
            <div v-else class="mt15">
              <v-btn rounded
                color="profileAnchorColor"
                class="button-with-icon text-none white--text"
                @click="addNote"
                :disabled="noteText.trim() == ''"
              >
                Add note
            </v-btn>
            </div>
          </div>
          <div
            v-if="currentContentBriefNotes.length > 0"
            class="mt5 box" style="max-height: 400px; overflow: auto;">
            <article
              class="message is-info"
              v-for="row in currentContentBriefNotes"
              :key="row.id"
            >
              <div class="message-header">
                <p>
                  {{ row.createdAt }}
                  <span v-if="row.isEdited" class="is-italic is-size-7">
                    ( edited: {{ row.editedAt }} )</span
                  >
                </p>
                <div>
                  <button
                    class="button is-small"
                    aria-label="delete"
                    @click="setEditNoteMode(row)"
                    v-if="!row.isAutoNote"
                  >
                    Edit
                  </button>
                  <button
                    v-if="!hideActionButtons"
                    class="button is-small is-dark"
                    aria-label="delete"
                    @click="deleteNote(row.id)"
                  >
                    Delete
                  </button>
                </div>
              </div>
              <div class="message-body">
                <p v-html="row.note.replace(/\n/g, '<br/>')"></p>
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal"
      :class="{ 'is-active': showRemoveRecoverTermConfirmModal }"
    >
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box modal-container" style="overflow: hidden;">
          <div class="pad25">
            <div class="title-font is-size-4 mb20">Confirm</div>
            <div class="subtitle">
              {{
                selectedCBData && selectedCBData.action == "remove"
                  ? "Do you really want to remove the term?"
                  : "Do you really want to recover the term?"
              }}
            </div>
            <label class="checkbox">
              <input
                type="checkbox"
                v-model="donotShowAgainWarningForRemoveRecoverCBTerm"
              />
              Please do not show this warning again.
            </label>
          </div>
          <div class="has-background-light pad25 has-text-right">
            <button
              class="button ready-button"
              @click="performRemoveRecoverAction"
              :disabled="!selectedCBData"
            >
              {{
                selectedCBData && selectedCBData.action == "remove"
                  ? "Remove it"
                  : "Recover it"
              }}
            </button>
            <button
              class="button is-light"
              @click="() => (showRemoveRecoverTermConfirmModal = false)"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>

    <page-setting-modal ref="pageSettingModal" :disableDeletePage="true" />

    <div v-if="selectedCBItems.length > 0" class="action-bar">
      <div class="left-area">
        {{ selectedCBItems.length }}
      </div>
      <div class="middle-area">
        <div class="item-selected-text">
          {{ selectedCBItems.length > 1 ? 'items': 'item' }} selected
        </div>
        <div
          class="remove-btn"
          @click="removeTerms">
          <span class="material-icons-outlined">delete_sweep</span>
          <span>Remove</span>
        </div>
        
      </div>
      <div class="right-area">
        <span class="material-icons close-button"
          @click="() =>{
            selectedCBItems = []
          }">
          close
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { downloadServedFile } from '@/utils/served-files'
import { FulfillingSquareSpinner } from 'epic-spinners'
import { mixin as cb_mixin } from "./cb_mixin";
import { StopLightBGColorOptions } from '@/components/PageRun/ContentBrief/content_brief_constants.js'
import PageSettingModal from "@/components/PageSettingModal.vue";
import { TARGET_MIN_PERCENTAGE } from "@/components/PageRun/constants";
import { mixin as ContentBriefMixin } from '@/components/content_brief_mixin'

let stateColors = [
  "#FE525C",
  "#FD777F",
  "#FCA2A8",
  "#96E8B3",
  "#64DF90",
  "#96E8B3",
  "#FCD4A8",
  "#FDC17F",
  "#FEB15C"
];
let borderColors = [
  "#FF1F2D",
  "#FF1F2D",
  "#FF1F2D",
  "#00CD49",
  "#00CD49",
  "#00CD49",
  "#FF9B2D",
  "#FF9B2D",
  "#FF9B2D"
];

let stoplightColor = [
  "#FF1F2D",
  "#FF6266",
  "#FF8F91",
  "#22DC7C",
  "#00CD49",
  "#22DC7C",
  "#FF9B2D",
  "#FFB95A",
  "#FF9B2D"
];

let TYPE_ORDER = { keyword: 0, variation: 1, lsi: 2 };

export default {
  props: [
    "selectedMainTab",
    "createdAt",
    "url",
    "fakeScore",
    "keyword",
    "secondaryKeywords",
    "lsaPhrases",
    "pageRunId",
    "pageNotBuilt",
    "page",
    "ignoreSpaces",
    "willUseSecretKey",
    "secretKey",
    "contentBrief",
    "runStrategies",
    "tagTotalData",
    "wordCountData",
    "sectionCount",
    "gCompetitors",
    "relatedSearches",
    "relatedQuestions",
    "contentBriefFile",
    "isFromExtension",
    "showAsMobileView",
    "hideActionButtons",
    "excludedTerms",
    "isAIMode",
    "isCalculating",
  ], // showAsMobileView : this will be true if this component will display inside extension modal or source editor modal
  mixins: [cb_mixin, ContentBriefMixin],
  components: {
    PageSettingModal,
    FulfillingSquareSpinner,
  },
  data() {
    return {
      expandedQuestion: "",
      sortMethod: "importance",
      showMorePageStructure: false,
      showMoreGCompetitors: false,
      showMoreRelatedSearches: false,
      showMoreRelatedQuestions: false,

      showPageTitleExplainText: false,
      showSubtitlesExplainText: false,
      showMainContentExplainText: false,

      termDispType: "table", // table/list
      isCollapseSummaryArea: false,
      isCollapseSearchEngineTitleArea: false,
      isCollapsePageTitleArea: false,
      isCollapseSubHeadingsArea: false,
      isCollapseMainContentArea: false,

      showNoteModal: false,
      selectedSection: "title", // title/subHeadings/p
      noteText: "",
      notes: [],
      currentNote: null, // in create mode this will be null, in edit mode this will be note

      TARGET_MIN_PERCENTAGE: TARGET_MIN_PERCENTAGE,

      showRemoveRecoverTermConfirmModal: false,
      donotShowAgainWarningForRemoveRecoverCBTerm: false,
      selectedCBData: null,
      selectedCBItems: [],
    };
  },
  computed: {
    isDemo () {
      return this.$store.getters.isDemoUser
    },
    user() {
      return this.$store.state.user;
    },

    nlpTerms() {
      let terms = this.lsaPhrases.reduce((rlt, item) => {
        if (item.isNLPTerm) {
          rlt.push(item.phrase);
        }
        return rlt;
      }, []);
      return terms;
    },
    googleNlpTerms() {
      let terms = this.lsaPhrases.reduce((rlt, item) => {
        if (item.isGoogleNLPTerm) {
          rlt.push(item.phrase);
        }
        return rlt;
      }, []);
      return terms;
    },
    contentBriefStatus() {
      let status = {};
      if (this.page && this.page.contentBriefStatus) {
        status = this.page.contentBriefStatus;
      }
      if (!status["title"]) status["title"] = "InCompleted";
      if (!status["subHeadings"]) status["subHeadings"] = "InCompleted";
      if (!status["p"]) status["p"] = "InCompleted";
      return status;
    },
    currentContentBriefNotes() {
      return this.notes.filter(item => item.type == this.selectedSection);
    },
    cleanedContentBrief() {
      if (this.contentBrief) {
        return this.contentBrief;
      }
      let found = this.runStrategies.find(
        item => item.dashboardType == "contentBrief"
      );
      if (found) {
        return found;
      }
      return {};
    },
    hasContentBriefData() {
      return (
        !!this.cleanedContentBrief &&
        Object.keys(this.cleanedContentBrief).length > 0
      );
    },
    hasPageTitleData() {
      return !!this.cleanedContentBrief["pageTitle"];
    },

    titleData() {
      return this.sortContentBriefData("title", this.cleanedContentBrief["title"]);
    },
    pageTitleData() {
      return this.sortContentBriefData(
        "pageTitle",
        this.cleanedContentBrief["pageTitle"] || []
      );
    },
    subHeadingsData() {
      return this.sortContentBriefData("subHeadings", this.cleanedContentBrief["subHeadings"]);
    },
    /**
     * Function Name: bodyContentData
     * if user is in Pro tab, then limit main content size to 30
     * else, display all the elements.
     */
    bodyContentData() {
      if (
        this.cleanedContentBrief["p"].length > 30 &&
        this.selectedMainTab == "standard"
      ) {
        return this.sortContentBriefData(
          "p",
          this.cleanedContentBrief["p"].slice(0, 30)
        );
      } else {
        return this.sortContentBriefData("p", this.cleanedContentBrief["p"]);
      }
    },
    titleTotal() {
      return this.cleanedContentBrief["titleTotal"];
    },
    pageTitleTotal() {
      return (
        this.cleanedContentBrief["pageTitleTotal"] || {
          current: 0,
          min: 0,
          max: 0
        }
      );
    },
    subTitleTotal() {
      return this.cleanedContentBrief["subHeadingsTotal"];
    },
    contentTotal() {
      return this.cleanedContentBrief["pTotal"];
    },
    excludedTermsForTitle() {
      return this.excludedTerms.title || [];
    },
    excludedTermsForPageTitle() {
      return this.excludedTerms.pageTitle || [];
    },
    excludedTermsForSubHeadings() {
      return this.excludedTerms.subHeadings || [];
    },
    excludedTermsForP() {
      return this.excludedTerms.p || [];
    },
    score() {
      return this.cleanedContentBrief["pageScore"]["pageScore"];
    },
    subHeadingsTarget() {
      return this.sectionCount
    },

    uniqueUrlForEditor() {
      if (!this.secretKey) return "";
      let routeData = this.$router.resolve({
        name: "FullPageSourceEditor",
        query: { secretKey: this.secretKey }
      });
      return window.location.origin + "/" + routeData.href;
    },
    selectedSecitonDisplayName() {
      switch (this.selectedSection) {
        case "title":
          return "Search Engine Title";
        case "pageTitle":
          return "Page Title";
        case "subHeadings":
          return "SubHeadings";
        case "p":
          return "Main Content";
        default:
          return "";
      }
    },
    scoreStatusMsg () {
      return this.scoreToText(this.score)
    }
  },
  watch: {
    isAIMode: function (val) {
      console.log('watch function is called bb', val);
      if (val == true) {
        this.collapseAllContentBriefSection();
      }
    }
  },
  methods: {
    fakeWC () {
      if (!this.$store.getters.isDemoUser) return;

      const aiStep = this.$store.getters.aiWriterStep;
      const isMainDone = this.$store.state.isDemoMainContentDone;
      if (isMainDone && aiStep > 6) return parseInt(this.wordCountData[1])
      else if (aiStep > 6) return parseInt(this.wordCountData[1] * 0.7)
      else if (aiStep > 5) return parseInt(this.wordCountData[1] * 0.4)
      else if (aiStep > 4) return parseInt(this.wordCountData[1] * 0.3)
    },
    collapseAllContentBriefSection () {
      this.isCollapseSearchEngineTitleArea =  true;
      this.isCollapsePageTitleArea =  true;
      this.isCollapseSubHeadingsArea =  true;
      this.isCollapseMainContentArea =  true;
    },
    enterPageSetting() {
      // console.log(this.page)
      // console.log(this.$refs.pageSettingModal)
      this.$refs.pageSettingModal.show(this.page);
    },
    isSecondaryKeyword(term) {
      let secondaryKeywords = this.secondaryKeywords || [];
      return secondaryKeywords.includes(term);
    },
    isNLPTerm(term) {
      return (this.nlpTerms || []).includes(term);
    },
    isGoogleNLPTerm(term) {
      return (this.googleNlpTerms || []).includes(term);
    },
    performRemoveRecoverAction() {
      if (!this.selectedCBData) {
        console.log("no any item selected");
        return;
      }
      this.showRemoveRecoverTermConfirmModal = false;
      console.log("Selected data", this.selectedCBData);
      switch (this.selectedCBData.action) {
        case "remove":
          this.removeTerm();
          break;
        case "recover":
          this.recoverTerm();
          break;
        default:
          break;
      }
    },
    removeOrRecoverTerm(action, item, sectionName) {
      let doNotNeedDisplayConfirmModal;

      this.selectedCBData = {
        action,
        item,
        sectionName
      };
      switch (action) {
        case "remove":
          doNotNeedDisplayConfirmModal =
            this.user.settings.dontDisplayCBRemoveConfirmModal || false;
          if (doNotNeedDisplayConfirmModal) {
            setTimeout(() => {
              this.performRemoveRecoverAction();
            }, 100);
          } else {
            this.donotShowAgainWarningForRemoveRecoverCBTerm = false;
            this.showRemoveRecoverTermConfirmModal = true;
          }
          break;
        case "recover":
          doNotNeedDisplayConfirmModal =
            this.user.settings.dontDisplayCBRecoverConfirmModal || false;
          if (doNotNeedDisplayConfirmModal) {
            setTimeout(() => {
              this.performRemoveRecoverAction();
            }, 100);
          } else {
            this.donotShowAgainWarningForRemoveRecoverCBTerm = false;
            this.showRemoveRecoverTermConfirmModal = true;
          }
          break;
        default:
          break;
      }
    },
    removeTerm() {
      let { item, sectionName } = this.selectedCBData;
      let data = {
        siteId: this.page.siteId,
        pageId: this.page.id,
        pageRunId: this.pageRunId,
        sectionName,
        termData: item
      };
      if (this.donotShowAgainWarningForRemoveRecoverCBTerm) {
        data["doNotDisplayWarningAgain"] = true;
      }
      this.$store.commit("showLoading");
      this.$store
        .dispatch("removeTermFromCB", data)
        .then(response => {
          if (response.data && response.data.status == "SUCCESS") {
            this.$notify({
              group: 'info', type: 'success',
              title: 'Alert', text: 'Success!'
            });
            if (response.data.pageRun) {
              this.$store.commit("updatePageRun", response.data.pageRun);
            }
            if (response.data.user) {
              this.$store.commit("setUser", response.data.user);
            }

            this.$emit('needChecklistUpdate')
          } else {
            this.$notify({
              group: 'info', type: 'error',
              title: 'Alert', text: 'Failed to remove term.'
            });
          }
        })
        .finally(() => {
          this.$store.commit("hideLoading");
        });
    },
    recoverTerm() {
      let { item, sectionName } = this.selectedCBData;
      let data = {
        siteId: this.page.siteId,
        pageId: this.page.id,
        pageRunId: this.pageRunId,
        sectionName,
        termData: item
      };

      if (this.donotShowAgainWarningForRemoveRecoverCBTerm) {
        data["doNotDisplayWarningAgain"] = true;
      }

      this.$store.commit("showLoading");
      this.$store
        .dispatch("recoverTermForCB", data)
        .then(response => {
          if (response.data && response.data.status == "SUCCESS") {
            this.$notify({
              group: 'info', type: 'success',
              title: 'Alert', text: 'Success!'
            });
            if (response.data.pageRun) {
              this.$store.commit("updatePageRun", response.data.pageRun);
            }
            if (response.data.user) {
              this.$store.commit("setUser", response.data.user);
            }
          } else {
            this.$notify({
              group: 'info', type: 'error',
              title: 'Alert', text: 'Failed to recover term.'
            });
          }
        })
        .finally(() => {
          this.$store.commit("hideLoading");
        });
    },
    removeTerms() {
      if (this.selectedCBItems.length == 0) {
        this.$notify({
          group: 'info', type: 'warning',
          title: 'Alert', text: 'Please select terms you want to remove.'
        })
        return;
      }
      let data = {
        siteId: this.page.siteId,
        pageId: this.page.id,
        pageRunId: this.pageRunId,
        selectedTerms: this.selectedCBItems,
      };
      if (this.donotShowAgainWarningForRemoveRecoverCBTerm) {
        data["doNotDisplayWarningAgain"] = true;
      }
      this.$store.commit("showLoading");
      this.$store
        .dispatch("removeTermsFromCB", data)
        .then(response => {
          if (response.data && response.data.status == "SUCCESS") {
            this.selectedCBItems = []
            this.$notify({
              group: 'info', type: 'success',
              title: 'Alert', text: 'Success!'
            });
            if (response.data.pageRun) {
              this.$store.commit("updatePageRun", response.data.pageRun);
            }
            if (response.data.user) {
              this.$store.commit("setUser", response.data.user);
            }
            this.$emit('needChecklistUpdate')
          } else {
            this.$notify({
              group: 'info', type: 'error',
              title: 'Alert', text: 'Failed to remove term.'
            });
          }
        })
        .finally(() => {
          this.$store.commit("hideLoading");
        });
    },
    getDateAsLocalString(dateStr) {
      return new Date(dateStr.replace(" ", "T") + "Z").toLocaleString();
    },
    getSubFolderPartFromUrl(url) {
      if (this.pageNotBuilt) {
        return "N / A";
      }
      if (!url || url.length <= 8) {
        return "";
      }
      let idx = url.indexOf("/", 8);
      let rlt = url.substr(idx).trim();

      if (idx == -1 || rlt == "/" || rlt == "") {
        return "Homepage";
      }
      return rlt;
    },
    openUrlInNewTab(url) {
      window.open(url, "_blank");
    },
    updateContentBriefSectionStatus(sectionName, status) {
      // this.contentBriefStatus[sectionName])
      if (this.contentBriefStatus[sectionName] == status) {
        return;
      }
      let data = {
        willUseSecretKey: this.willUseSecretKey,
        secretKey: this.secretKey,
        pageId: this.page.id,
        sectionName,
        status
      };
      this.$store.commit("showLoading");
      this.$store
        .dispatch("updateContentBriefStatus", data)
        .then(response => {
          if (response.data && response.data.status == "SUCCESS") {
            if (response.data.page) {
              if (this.isFromExtension) {
                this.$emit("updateCurrentPage", response.data.page);
              } else {
                this.$store.commit("setPage", response.data.page);
              }
            }
          }
        })
        .finally(() => this.$store.commit("hideLoading"));
    },
    displayNoteModalFor(sectionName) {
      this.selectedSection = sectionName;
      this.showNoteModal = true;
    },
    hideNoteModalAction() {
      this.showNoteModal = false;
      this.currentNote = null;
    },
    cancelEditNoteMode() {
      this.currentNote = null;
    },
    addNote() {
      let data = {
        willUseSecretKey: this.willUseSecretKey,
        secretKey: this.secretKey,
        pageRunId: this.pageRunId,
        type: this.selectedSection,
        note: this.noteText
      };
      this.$store.commit("showLoading");
      this.$store
        .dispatch("createContentBriefNote", data)
        .then(response => {
          if (response.data && response.data.status == "SUCCESS") {
            let note = response.data.note;
            this.notes = [note, ...this.notes];
            this.noteText = "";
          }
        })
        .finally(() => this.$store.commit("hideLoading"));
    },
    setEditNoteMode(note) {
      this.currentNote = note;
      this.noteText = note.note;
    },
    updateNote() {
      this.$store.commit("showLoading");
      this.$store
        .dispatch("updateContentBriefNote", {
          willUseSecretKey: this.willUseSecretKey,
          secretKey: this.secretKey,
          noteId: this.currentNote.id,
          note: this.noteText
        })
        .then(response => {
          if (response.data && response.data.status == "SUCCESS") {
            let updatedNote = response.data.note;
            this.notes = this.notes.map(item => {
              if (item.id == updatedNote.id) {
                return updatedNote;
              }
              return item;
            });
            this.noteText = "";
            this.currentNote = null;
          }
        })
        .finally(() => {
          this.$store.commit("hideLoading");
        });
    },
    deleteNote(noteId) {
      if (!window.confirm("Do you want to delte this note ?")) {
        return;
      }
      this.$store.commit("showLoading");
      this.$store
        .dispatch("deleteContentBriefNote", noteId)
        .then(response => {
          if (response.data && response.data.status == "SUCCESS") {
            let updatedNote = response.data.note;
            this.notes = this.notes.filter(item => {
              if (item.id == noteId) {
                return false;
              }
              return true;
            });
            this.noteText = "";
            this.currentNote = null;
          }
        })
        .finally(() => {
          this.$store.commit("hideLoading");
        });
    },

    sortContentBriefData(contentType, contentBriefData) {
      let data = contentBriefData;
      const colors = Object.keys(StopLightBGColorOptions).map(key=>StopLightBGColorOptions[key]).sort((a,b)=>(a.order - b.order)).map(c=>c.color)

      data.sort((a, b) => {
        if (this.sortMethod == "status") {
          const acolorIndex = colors.indexOf(this.getStopLightColorForItem(contentType, a))
          const bcolorIndex = colors.indexOf(this.getStopLightColorForItem(contentType, b))
          return acolorIndex - bcolorIndex
        }
        if (this.sortMethod == "alphabetic") {
          if (a.term.phrase < b.term.phrase) return -1;
          else if (a.term.phrase > b.term.phrase) return 1;
          return 0;
        } else {
          if (a.term.type == b.term.type) {
            if (this.sortMethod == "importance") {
              if (a.term.weight < b.term.weight) return 1;
              else if (a.term.weight > b.term.weight) return -1;
              return 0;
            } else if (this.sortMethod == "deficit") {
              if (a.term.weight < b.term.weight) return -1;
              else if (a.term.weight > b.term.weight) return 1;
              return 0;
            }
          } else {
            if (this.sortMethod == "importance") {
              if (TYPE_ORDER[`${a.term.type}`] < TYPE_ORDER[`${b.term.type}`])
                return -1;
              if (TYPE_ORDER[`${a.term.type}`] > TYPE_ORDER[`${b.term.type}`])
                return 1;
              return 0;
            } else if (this.sortMethod == "deficit") {
              if (TYPE_ORDER[`${a.term.type}`] < TYPE_ORDER[`${b.term.type}`])
                return 1;
              if (TYPE_ORDER[`${a.term.type}`] > TYPE_ORDER[`${b.term.type}`])
                return -1;
              return 0;
            }
          }
        }
      });
      return data;
    },
    downloadAsTxt(contentBriefType) {
      let fileName = "";
      let data = "";
      switch (contentBriefType) {
        case "title":
          this.titleData.map(item => {
            data += `${item.term.phrase} ( ${item.contentBrief.current} / ${
              item.term.type == "keyword"
                ? item.contentBrief.target
                : item.contentBrief.targetMin +
                  " - " +
                  item.contentBrief.targetMax
            } )\r\n`;
          });
          fileName = `ContentBrief_${contentBriefType}.txt`;
          break;
        case "pageTitle":
          this.pageTitleData.map(item => {
            data += `${item.term.phrase} ( ${item.contentBrief.current} / ${
              item.term.type == "keyword"
                ? item.contentBrief.target
                : item.contentBrief.targetMin +
                  " - " +
                  item.contentBrief.targetMax
            } )\r\n`;
          });
          fileName = `ContentBrief_${contentBriefType}.txt`;
          break;
        case "subHeadings":
          fileName = `ContentBrief_${contentBriefType}.txt`;
          this.subHeadingsData.map(item => {
            data += `${item.term.phrase} ( ${item.contentBrief.current} / ${
              item.term.type == "keyword"
                ? item.contentBrief.target
                : item.contentBrief.targetMin +
                  " - " +
                  item.contentBrief.targetMax
            } )\r\n`;
          });
          break;
        case "p":
          fileName = `ContentBrief_BodyContent.txt`;
          this.bodyContentData.map(item => {
            data += `${item.term.phrase} ( ${item.contentBrief.current} / ${
              item.term.type == "keyword"
                ? item.contentBrief.target
                : item.contentBrief.targetMin +
                  " - " +
                  item.contentBrief.targetMax
            } )\r\n`;
          });
          break;
      }
      if (data) {
        var element = document.createElement("a");
        element.setAttribute(
          "href",
          "data:text/plain;charset=utf-8," + encodeURIComponent(data)
        );
        element.setAttribute("download", fileName);

        element.style.display = "none";
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
      }
    },

    pageScoreTintColor(score) {
      let value = score ? score : 0;
      if (value >= 0 && value <= 69) {
        return "#FF0000";
      } else if (value > 69 && value <= 74) {
        return "#FF9C00";
      } else if (value > 74 && value <= 80) {
        return "#FFC000";
      } else if (value > 80 && value <= 83) {
        return "#8CCFB5";
      } else if (value > 83 && value <= 85) {
        return "#78C8A5";
      } else if (value > 85 && value <= 88) {
        return "#5EC198";
      } else if (value > 88 && value <= 90) {
        return "#00B482";
      } else if (value > 90 && value <= 93) {
        return "#00925D";
      } else if (value > 93 && value <= 95) {
        return "#008452";
      } else if (value > 95) {
        return "#006A42";
      }
      return "#000000";
    },
    getBlockBGAndBorder(type, item) {
      return ["transparent", borderColors[8]];

      let { current, target, targetMin, targetMax } = item.contentBrief;

      let targetValue = 0;
      if (type == "keyword") {
        targetValue = target;
      } else {
        if (targetMin > 0) targetValue = targetMin;
        else targetValue = targetMax / 2;
      }

      if (targetValue == 0) return stateColors[4];
      let value = (current * 100.0) / targetValue;

      if (value >= 0 && value <= 20) {
        return [stateColors[0], borderColors[0]];
      } else if (value > 20 && value <= 40) {
        return [stateColors[1], borderColors[1]];
      } else if (value > 40 && value <= 60) {
        return [stateColors[2], borderColors[2]];
      } else if (value > 60 && value <= 80) {
        return [stateColors[3], borderColors[3]];
      } else if (value > 80 && value <= 100) {
        return [stateColors[4], borderColors[4]];
      } else if (value > 100 && value <= 120) {
        return [stateColors[5], borderColors[5]];
      } else if (value > 120 && value <= 140) {
        return [stateColors[6], borderColors[6]];
      } else if (value > 140 && value <= 160) {
        return [stateColors[7], borderColors[7]];
      } else if (value > 160) {
        return [stateColors[8], borderColors[8]];
      }
    },
    occurrencesInString(str, findingWord) {
      if (this.ignoreSpaces) {
        return (str.match(new RegExp(findingWord, "gi")) || []).length;
      } else {
        return (str.match(new RegExp(`\\b${findingWord}\\b`, "gi")) || [])
          .length;
      }
    },
    needsToDisplayUseAlone(sectionName, item) {
      let data = [];
      switch (sectionName) {
        case "title":
          data = this.pageTitleData;
          break;
        case "subHeadings":
          data = this.subHeadingsData;
          break;
        case "p":
          data = this.bodyContentData;
          break;
        default:
          break;
      }
      let rlt = false;
      data.map(obj => {
        if (
          obj.term.phrase != item.term.phrase &&
          this.occurrencesInString(obj.term.phrase, item.term.phrase)
        ) {
          rlt = true;
        }
      });
      return rlt;
    },
    getTooltipForColor(color) {
      switch (color) {
        case StopLightBGColorOptions.red.color:
          return 'You are below the target range for this term.  We recommend increasing the use of this term to get into the target range. '
          break;
        case StopLightBGColorOptions.yellow.color:
          return 'You are below the target range for this term.  We recommend increasing the use of this term to get into the target range. '
          break;
        case StopLightBGColorOptions.green.color:
          return 'You are in the target range for this term.  We recommend reaching at least the mid-point of all target ranges for best results.'
          break;
        case StopLightBGColorOptions.purple.color:
          return 'While you are over the target range for this term, we do not recommend reducing this term until you have increased the use of other terms first'
          break;
      
        default:
          return ''
          break;
      }
    },
    getStopLightStateTextForSection(contentBriefType) {
      const isMainDone = this.$store.state.isDemoMainContentDone;
      const isHeadingsDone = this.$store.state.isDemoHeadingsDone;
      if (this.isDemo) {
        if ((contentBriefType === 'subHeadings' && !isHeadingsDone) || (contentBriefType === 'p' && !isMainDone)) {
          return ['UNDEROPTIMIZED', { 'underoptimize-1': true }]
        }
        return ['OPTIMIZED', { 'optimized': true }]
      }
      let current = 0,
        targetMin = 0,
        targetMax = 0;
      switch (contentBriefType) {
        case "title":
          current = this.titleTotal["current"];
          targetMin = this.titleTotal["min"];
          targetMax = this.titleTotal["max"];
          break;
        case "pageTitle":
          current = this.pageTitleTotal["current"];
          targetMin = this.pageTitleTotal["min"];
          targetMax = this.pageTitleTotal["max"];
          break;
        case "subHeadings":
          current = this.subTitleTotal["current"];
          targetMin = this.subTitleTotal["min"];
          targetMax = this.subTitleTotal["max"];
          break;
        case "p":
          current = this.contentTotal["current"];
          targetMin = this.contentTotal["min"];
          targetMax = this.contentTotal["max"];
          break;
        default:
          break;
      }
      let state = this.getStopLightStateText(
        contentBriefType,
        current,
        targetMin,
        targetMax,
        true
      );
      switch (state) {
        case 'underoptimized2':
          return ['UNDEROPTIMIZED', { 'underoptimize-2' : true }]
        case 'underoptimized1':
          return ['UNDEROPTIMIZED', { 'underoptimize-1': true }]
        case 'optimized':
          return ['OPTIMIZED', { 'optimized': true }]
        default:
          return ['', '']
      }
    },
    showNoSecondaryKeywordsInSection (contentBriefType) {
      if (this.secondaryKeywords && this.secondaryKeywords.length == 0) {
        return false;
      }

      let data = [];
      switch (contentBriefType) {
        case "title":
          data = this.titleData;
          break;
        case "pageTitle":
          data = this.pageTitleData;
          break;
        case "subHeadings":
          data = this.subHeadingsData;
          break;
        case "p":
          data = this.bodyContentData;
          break;
        default:
          break;
      }
      let terms = data.map(item => item.term.phrase);
      for (const keyword of this.secondaryKeywords) {
        if (terms.includes(keyword)) {
          return false;
        }
      }
      return true;
    },
    loadNotes() {
      this.$store
        .dispatch("getContentBriefNotes", {
          pageRunId: this.pageRunId,
          willUseSecretKey: this.willUseSecretKey,
          secretKey: this.secretKey
        })
        .then(response => {
          if (response.data && response.data.status == "SUCCESS") {
            this.notes = response.data.notes;
          }
        });
    },
    downloadContentBrief(downloadType) {
      switch (downloadType) {
        case "excel":
        case "pdf":
          this.$store
            .dispatch("downloadContentBrief", { downloadType, pageRunId: this.pageRunId })
            .then(response => {
              if (response.data && response.data.status == "SUCCESS") {
                let contentBriefDataFile = response.data.contentBriefDataFile;
                let downloadUrl = "";
                let fileName = "";
                switch (downloadType) {
                  case "excel":
                    fileName = contentBriefDataFile["excel"]
                    break;
                  case "pdf":
                    fileName = contentBriefDataFile["pdf"]
                    break;
                }
                                downloadServedFile(fileName, { secretKey: this.secretKey || '' });
              } else {
                console.log("failed to make content brief");
              }
            })
            .catch(error => {
              console.log("error check server side");
            });
          break;
        default:
          break;
      }
    },
    downloadFile(downloadUrl) {
      if (!downloadUrl) return;
      let fileName = downloadUrl.split("/").pop();
      let downloadLink;
      downloadLink = document.createElement("a");
      downloadLink.download = fileName;
      downloadLink.href = downloadUrl;
      downloadLink.style.display = "none";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      setTimeout(() => {
        document.body.removeChild(downloadLink);
      }, 100);
    }
  },
  mounted() {
    if (!this.isFromExtension || this.willUseSecretKey) {
      this.loadNotes();
    }
    if (this.isAIMode) {
      this.collapseAllContentBriefSection();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./content-brief.scss";

.copy-to-clipboard-button {
  width: 12px;
  margin-right: 0.3rem;
  cursor: pointer;
}
.font-large {
    font-size: 20px;
    font-weight: bold;
}

.font-bold {
    font-weight: bold;
}
.report-card-dot {
  float: right;
}
.my-notes-btn {
  display: inline-flex;
  align-items: center;
  i {
    font-size: 12px;
    margin-right: 5px;
  }
 color: var(--v-profileAnchorColor-base);
}
.show-hide-link {
  font-size: 12px;
  line-height: 24px;
  text-decoration: underline;
  color: var(--v-linkColor-base);
}
.stoplights-box {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  margin: 0 0 0 5px;
  background: lightgray;
}
.section-count-disp {
  display: flex;
  align-items: center;
  gap: 20px;
  * {
    color: var(--v-darkGrayColor-base);
  }
  .section-count-number {
    font-size: 14px;
    font-weight: bold;
    color: var(--v-mainColor-base);
  }
}

.section-state-box {
  padding: 5px 10px 5px 20px;
  border-radius: 5px;
  font-weight: bold;
  font-size: 10px;
  position: relative;
  &::before {
    position: absolute;
    content: '';
    width: 5px;
    height: 5px;
    border-radius: 5px;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
  }

  &.underoptimize-2 {
    background: var(--v-red4Color-base);
    color: var(--v-red3Color-base);
    &::before {
      background: var(--v-red3Color-base);
    }
  }
  &.underoptimize-1 {
    background: var(--v-yellow3Color-base);
    color: var(--v-yellow4Color-base);
    &::before {
      background: var(--v-yellow4Color-base);
    }
  }
  &.optimized {
    background: var(--v-green6Color-base);
    color: var(--v-green7Color-base);
    &::before {
      background: var(--v-green7Color-base);
    }
  }
}
</style>
